import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize({
  pt_BR,
});

const timeValidator = (value) => {
  if (value.length < 5) return false;
  const [horas, minutos] = value.split(":").map((val) => parseInt(val, 10));
  return horas < 24 && minutos < 60;
};

const cpfValidator = (value) => {
  if (!value) return true;

  const cpf = value.replace(/[^\d]/g, "");

  if (cpf.length !== 11) return false;

  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9), 10)) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10), 10)) return false;

  return true;
};

extend("timeValidator", timeValidator);
extend("cpf", {
  validate: cpfValidator,
  message: "CPF inválido",
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
localize("pt_BR");
setInteractionMode("eager");

extend("max_chars", {
  params: ["length"],
  validate(value, { length }) {
    if (!value) return true;
    return value.length <= length;
  },
  message: "O texto não pode exceder {length} caracteres",
});

extend("no_special_chars", {
  validate(value) {
    if (!value) return true;

    // Regex que permite: letras (com acentos), números, espaços e pontuação básica
    const regex = /^[a-zA-ZÀ-ÿ0-9\s.,;:!?()[\]{}"'`´~^°ªº\-_/\\+=*@#$%&\n\r]+$/;

    // Detecta emojis
    const emojiRegex =
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}]/u;

    if (emojiRegex.test(value)) {
      return false;
    }

    return regex.test(value);
  },
  message: "Não são permitidos emojis ou caracteres especiais inválidos",
});
